import * as React from 'react';
import {useApiQuery} from 'src/hooks/useApiQuery';
import type {FilterDefinition} from 'src/types/byod';
import {BYOD_API_BASE as BASE} from 'src/components/analytics-genesis/byod/api';
import {byodQueryDefaults} from 'src/components/analytics-genesis/byod/api/error-handling';

// Hard limit — if filter catalog exceeds this, results will be truncated
const FILTER_DEFINITIONS_LIMIT = 100;

type FilterListResponse = {
  filters: FilterDefinition[];
  pagination: {total_count: number; page_size: number; offset: number};
};

export function useFilterDefinitions() {
  const {data, ...rest} = useApiQuery<FilterListResponse>(
    {
      pathname: `${BASE}/filters`,
      query: {limit: String(FILTER_DEFINITIONS_LIMIT), offset: '0'},
    },
    {
      queryOptions: {
        ...byodQueryDefaults,
        queryKey: ['byod-filter-definitions'],
        staleTime: 30 * 1000,
        gcTime: 60 * 1000,
      },
    },
  );

  const filterMap = React.useMemo<Record<string, FilterDefinition>>(() => {
    if (!data?.filters) {
      return {};
    }
    return Object.fromEntries(data.filters.map((f) => [f.key, f]));
  }, [data]);

  return {...rest, data: filterMap};
}
